<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="Location Settings" />
    </div>
    <Loader class="mt-4">
      <div class="row">
        <div class="col-6">
          <form @submit.prevent="saveLocationDetails">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label>Location Name</label>
                  <input
                    placeholder="Enter Location Name"
                    type="text"
                    class="form-control inp-bg"
                    v-model="locationDetails.locationName"
                    required
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>Description</label>
                  <textarea
                    placeholder="Location Description"
                    v-model="locationDetails.description"
                    class="form-control inp-bg"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label>Stretch Distance (In KMS)</label>
                  <input
                    placeholder="Distance in KMS"
                    type="number"
                    min="1"
                    max="1000"
                    class="form-control inp-bg"
                    v-model="locationDetails.distance"
                    required
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="mb-3">
                  <label>Start Chainage</label>
                  <input
                    placeholder="Ex: 0+0"
                    type="text"
                    class="form-control inp-bg"
                    v-model="locationDetails.startChainage"
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="mb-3">
                  <label>End Chainage</label>
                  <input
                    placeholder="Ex: 200+0"
                    type="text"
                    class="form-control inp-bg"
                    v-model="locationDetails.endChainage"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label>Start Latitude</label>
                  <input
                    placeholder="Enter Start Latitude"
                    class="form-control inp-bg"
                    v-model="locationDetails.startLatitude"
                    required
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label>Start Longitude</label>
                  <input
                    placeholder="Enter Start Longitude"
                    class="form-control inp-bg"
                    v-model="locationDetails.startLongitude"
                    required
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label>Center Latitude</label>
                  <input
                    placeholder="Enter Center Latitude"
                    class="form-control inp-bg"
                    v-model="locationDetails.centerLatitude"
                    required
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label>Center Longitude</label>
                  <input
                    placeholder="Enter Center Longitude"
                    class="form-control inp-bg"
                    v-model="locationDetails.centerLongitude"
                    required
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label>End Latitude</label>
                  <input
                    placeholder="Enter End Latitude"
                    class="form-control inp-bg"
                    v-model="locationDetails.endLatitude"
                    required
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label>End Longitude</label>
                  <input
                    placeholder="Enter End Longitude"
                    class="form-control inp-bg"
                    v-model="locationDetails.endLongitude"
                    required
                  />
                </div>
              </div>
            </div>

            <hr />

            <!-- BUTTON -->
            <div class="row">
              <div class="col-12">
                <div class="mt-2 text-center">
                  <button type="submit" class="btn btn-primary me-1 w-50">
                    {{ $t("menuitems.administration.list.location.list.save") }}
                    <i class="bx bx-rocket ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-6">
          <div class="mt-4 ms-2 me-2">
            <Map :key="renderMap" :location="locationDetails" />
          </div>
        </div>
      </div>
    </Loader>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import adminMixin from "@/mixins/administration";
import Loader from "@/components/widgets/loader.vue";
import Swal from "sweetalert2";
import Map from "@/components/location-settings/map.vue";
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Location Settings",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [adminMixin],
  data() {
    return {
      locationDetails: {},
      renderMap: false,
    };
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Map,
  },
  async mounted() {
    await this.getLocationDetails();
  },
  methods: {
    async getLocationDetails() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        this.renderMap = false;
        const res = await this.GetLocationDetails();
        this.locationDetails = {
          id: res.id,
          locationName: res.location_name,
          description: res.description,
          distance: res.distance,
          startLatitude: res.start_lat,
          startLongitude: res.start_long,
          centerLatitude: res.center_lat,
          centerLongitude: res.center_long,
          endLatitude: res.end_lat,
          endLongitude: res.end_long,
          startChainage: res.start_chainage,
          endChainage: res.end_chainage,
        };

        this.renderMap = true;
        this.$store.dispatch("layout/changeLoaderValue", false);
      } catch (e) {
        Swal.fire("Failed!", "Failed to fetch location details", "error");
        this.$store.dispatch("layout/changeLoaderValue", false);
      }
    },
    async saveLocationDetails() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        this.renderMap = false;
        await this.SaveLocationDetails(this.locationDetails);
        Swal.fire("Saved!", "Location details saved successfully", "success");
        await this.getLocationDetails();
        this.renderMap = true;
        this.$store.dispatch("layout/changeLoaderValue", false);
      } catch (e) {
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Failed!", "Failed to save location details", "error");
      }
    },
  },
};
</script>
